import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";

export type Body = {
  broken_service_id: number;
  penalty?: number;
};

export type Root = {
  detail?: string;
};

export const cancelReservation = async (bookingId: string, data: Body) => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }
  const response = await fetch(`${BASE_URL_API}/bookings/${bookingId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
    method: "PATCH",
    body: JSON.stringify(data),
  });

  if (response.status !== 204) {
    const { detail } = (await response.json()) as Root;
    if (detail) {
      throw new Error(detail);
    }

    throw new Error("Ocorreu um erro ao cancelar a reserva.");
  }
};
